import React from 'react'
function Footer() {
    return (
        <>
            <div className='d-flex justify-content-center text-center w-100 align-items-center' style={{background:'transparent',color:'white',position:'fixed', bottom:'0',zIndex:'1000'}}>
                <div>
                    Designed and Developed by Prajwal VK
                </div>
            </div>
        </>
    )
}

export default Footer
